'use client'

import React from 'react'
import { Button } from "@/components/ui/button"
import Header from './header'
import PfFooter from './footer'

export function PandoforceLayout({ children ,currentPage,isBookADemo=true}) {
  return (
    <div className="min-h-screen bg-white">
      <Header currentPage={currentPage} />
      {children}
      <PfFooter isBookADemo={isBookADemo} />
    </div>
  )
}